if (!customElements.get('items-mobile-product-submit')) {
  customElements.define(
    'items-mobile-product-submit',
    class ItemsMobileProductSubmit extends HTMLElement {
      connectedCallback() {
        this.originalButton = document.getElementById(this.dataset.buttonId);
        this.productForm = this.originalButton?.closest('product-form');
        this.button = this.querySelector('button');
        if (!this.productForm || !this.button) return;

        this.label = this.button.querySelector('span');
        this.spinner = this.button.querySelector('.loading__spinner');
        this.errorMessage = this.querySelector('.items-mobile-add-error');
        this.onClick = () => {
          if (!this.button.disabled) this.originalButton.click();
        };
        this.button.addEventListener('click', this.onClick);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.productForm, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'aria-haspopup'],
          childList: true,
          characterData: true,
          subtree: true,
        });
        this.sync();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
      }

      sync() {
        const loading = this.originalButton.classList.contains('loading');
        this.button.disabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
        this.button.setAttribute('aria-busy', String(loading));
        this.button.classList.toggle('loading', loading);
        this.label.textContent = this.originalButton.querySelector('span').textContent;
        this.spinner?.classList.toggle('hidden', !loading);

        const popup = this.originalButton.getAttribute('aria-haspopup');
        if (popup) this.button.setAttribute('aria-haspopup', popup);
        else this.button.removeAttribute('aria-haspopup');

        const originalError = this.productForm.querySelector('.product-form__error-message-wrapper');
        const errorText = originalError && !originalError.hidden
          ? originalError.querySelector('.product-form__error-message')?.textContent.trim()
          : '';
        this.errorMessage.textContent = errorText || '';
        this.errorMessage.hidden = !errorText;
      }
    }
  );
}
